<template>
  <div class="fertilizer-schedule single-step">
    <Header
      v-model="stage"
      :flag="stageInfo !== null && !loading ? stageInfo.length : null"
      :manual="manual"
      @upEvent="sync"
      @printEvent="printPdf"
      @manualEvent="stageUpdate"
    />

    <app-loading :loading="loading">

      <p
        style="color: #E8282F;"
        v-if="!stageInfo.length"
      >
        {{ $ml.get(`Now please click on 'Select Fertilizers' for the creation of your plan`) }}
      </p>

      <Table
        :stageInfo="stageInfo"
        :manual="manual"
        v-model="stageInfo"
        @change="saveManual"
      />

      <p class="total-cost" v-if="info.TotalCost">
        {{ $ml.get(`Total cost:`) }}
        <b>{{ $store.getters['user/currency'].symbol }} {{ (info.TotalCost).toFixed(2) }}</b>
      </p>

      <nutTable :stageInfo="stageInfo" :nutElems="nutElems"/>

    </app-loading>

  </div>
</template>

<script>
import API from '@/api'

import Header from './Header';
import Table from './Table';
import NutTable from './NutTable';

export default {
  data () {
    return {
      check: 0,
      loading: false,
      info: false,
      stage: 'stage',
      stageInfo: null,
      nutElems: [],
      units: {
        '0': 'ml/m3',
        '1': 'l/m3',
        '2': 'g/m3',
        '3': 'g/m3',
        '4': 'L',
        '5': 'L',
        '6': 'kg',
        '7': 'kg',
      },
      manual: false
    }
  },
  created: function () {
    this.sync();
  },
  methods : {
    sync: function () {
      this.loading = true;
      
      return API.program.getFertilizerSchedule(this.$route.params.programId).then(res => {
        this.info = res.data.data;

        this.parseInfo();
        this.info.stages.forEach(e => {
          e.SelectedFertilizers.Fertilizer.forEach(b => {
            this.check += b.Concentration;
          });
        });
        console.log(this.check);
        this.$store.dispatch('program/canGoToNextStep', true);
        this.$store.dispatch('program/steps/setCurrentStep', 'fertilizer-schedule');
      }).catch(err => {
        this.info = [];
        this.stageInfo = [];

        this.$store.dispatch('program/canGoToNextStep', false);
        this.$store.dispatch('program/steps/setCurrentStep', 'adjusted-values');
      })
      .finally(() => {
          this.loading = false;
      });      
    },
    parseInfo () {
      this.stageInfo = [];
      this.nutElems = Object.keys(this.info.stages[0].NeededAddition).map(function (key) {
        return key.split('_')[0];
      });

      for (var i in this.info.stages) {
        var stage = this.parseStage(this.info.stages[i]);
        this.stageInfo.push(stage);
      }

      this.nutNormalization();
    },

    nutNormalization: function () {
      this.nutElems = this.nutElems.filter((key) => {
        var flag = false;

        // var blocking = ['NO3', 'NH2', 'NH4'];
        var blocking = [];
        if (this.$store.getters['program/data'].type != 'hydroponic') {
          blocking = ['NH2', 'NO3', 'NH4'];
        }

        if (blocking.indexOf(key) == -1) {
          for (var i in this.stageInfo) {
            if (this.stageInfo[i].nutrients[key] && (this.stageInfo[i].nutrients[key].needed != 0 || this.stageInfo[i].nutrients[key].fert != 0) ) {
              flag = true;
              break;
            }
          }
        }
        console.log(flag)
        return flag;
      });


      this.nutElems.sort(function (a, b) {
        var temp = ['N', 'NO3','NH2', 'NH4', 'P', 'K', 'Ca', 'Mg', 'S'];
        var aI = temp.indexOf(a);
        var bI = temp.indexOf(b);

        if (aI == -1) {
          return 1;
        } else if (bI == -1) {
          return -1;
        }

        return aI - bI;
      });
    },
    parseStage (stage) {
      var result = {};
      result.name = stage.Name;
      result.id = stage.Id;
      result.ec = stage.IrrWaterEc;
      result.ph = stage.IrrWaterPh;
      result.duration = stage.Duration + ' ' + this.$ml.get(`days`);
      result.cost = (stage.StageCost).toFixed(2);
      result.ratios = stage.Ratios;

      result.alerts = {
        AcidAlert: stage.AcidAlert,
        FriendlyAlerts: stage.FriendlyAlerts,
        N_FormsAlert: stage.N_FormsAlert,
        PHAlerts: stage.PHAlerts,
        SevereAlerts: stage.SevereAlerts
      };

      var koef = 1;
      switch (this.stage) {
        case 'stage':
          result.recPer = stage.Duration + ' Days';
          break;
        case 'day':
          result.recPer = '1 Days';
          koef = 1 / stage.Duration;
          break;
        case 'week':
          result.recPer = '1 Week';
          koef = 7 / stage.Duration;
      }

      result.fertilizers = [];
      for (var i in stage.SelectedFertilizers.Fertilizer) {
        var res = {};
        res.name = stage.SelectedFertilizers.Fertilizer[i].Name;
        res.stateId = stage.SelectedFertilizers.Fertilizer[i].State;
        res.id = stage.SelectedFertilizers.Fertilizer[i].Id;
        res.cost = stage.SelectedFertilizers.Fertilizer[i].Cost;
        var tempConc = stage.SelectedFertilizers.Fertilizer[i].Concentration;
        res.concentration = ((tempConc * koef)*100)/100;
        res.concentration = !res.concentration ? 0 : res.concentration;

        res.unit = this.units[stage.SelectedFertilizers.Fertilizer[i].ConcentrationUnit];

        result.fertilizers.push(res);
      }

      result.nutrients = {};
      for (var key in stage.NeededAddition) {
        var res = {};

        res.name = key.split('_')[0];
        res.needed = stage.NeededAddition[key].toFixed(2);
        res.fert = stage.FertAddition[key].toFixed(2);

        res.accuracy = stage.Accuracy[key];
        result.nutrients[res.name] = res;

      }

      return result;
    },
    printPdf: async function () {
      var result = await API.pdf.getPdfForSchedule(this.$route.params.programId);
      var blob = new Blob([result.data], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'schedule.pdf';
      link.click();
    },
    stageUpdate: function () {
      this.manual = !this.manual;
    },
    saveManual() {
      for (let i in this.info.stages) {
        let fertilizers = this.info.stages[i]['SelectedFertilizers']['Fertilizer'];
        for(let f in fertilizers) {
          fertilizers[f]["Concentration"] = this.stageInfo[i].fertilizers[f].concentration;
        }
        this.info.stages[i]['SelectedFertilizers']['Fertilizer'] = fertilizers;
      }

      // let data = this.info.stages;
      // data.map(el => {
      //   console.log(el['SelectedFertilizers']['Fertilizer']);
      // })
      // console.log(this.info.stages);
      // var stageParce = this.stageInfo[index];
      // var stageOrigin = this.info.stages.find(item => item.Id == stageParce.id);

      // stageOrigin.SelectedFertilizers.Fertilizer.map(fertOrigin => {
      //   var fertParce = stageParce.fertilizers.find(item => item.id == fertOrigin.Id);
      //
      //   fertOrigin.Concentration = fertParce.concentration;
      // });

      API.program.updateFertilizerSchedule(this.$route.params.programId, this.info).then(res => {
        if (res.data.success == true) {
          this.info = res.data.data;
          this.parseInfo();
        }
      });
    },
    next () {
      var flag = false;
      for (var item of this.stageInfo) {
        for (var nut in item.nutrients) {

          if (item.nutrients[nut].needed > 0 && item.nutrients[nut].accuracy < 90) {
            flag = true;
          }
        }
      }

      if (!flag) {
        // this.$store.commit('program/fertigation/saveStagesFromSchedule', this.info.stages);
        this.$store.dispatch('program/goToNextStep');
      } else {
        this.$store.commit('modals/prompt/open', {
          onAccept: () => {
            // this.$store.commit('program/fertigation/saveStagesFromSchedule', this.info.stages);
            this.$store.dispatch('program/goToNextStep');
          },
          text: this.$ml.get(`Some of the nutrient requirements are still not fulfilled. Are you sure you want to continue?`),
        });
      }
    },
  },
  components: {
    Header,
    Table,
    NutTable
  },
  watch: {
    stage: function (val) {
      this.parseInfo();
    }
  }
}
</script>

<style lang="scss" scoped>

.fertilizer-schedule {
  // padding: 0 48px;

  // .buttons {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: flex-end;
  //   padding: 30px 0;

  //   > * {
  //     margin-left: 20px;
  //   }
  // }
  .total-cost {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    b {
      padding-left: 4px;
    }
  }
}

</style>
